const { isEmpty } = _uo.utility;

/**
 * Checks if an integration has universal tokens
 *
 * @param {Object} integration An integration.
 * @return {Boolean} Whether the integration has universal tokens.
 */
const hasUniversalTokens = ( integration ) => {
	// Check if the integration has universal tokens.
	return ! isEmpty( integration.tokens );
}

export default hasUniversalTokens;
